const state = reactive({
  positions: [],
  all_positions: [],
  loading: false,
})

export function usePositions() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchAllPositions(event) {
    state.loading = true
    try {
      const { data } = await storyblokApi.get('cdn/stories', {
        version: 'published',
        per_page: 100,
        language: locale.value,
        starts_with: 'career-at-dexon/',
        is_startpage: false,
        sort_by: '',
      })

      if (data)
        state.all_positions = data.stories
    }
    catch (error) {
      return sendError(event, createError({
        statusCode: 404,
        statusMessage: 'Unauthorized client error',
      }))
    }
    finally {
      state.loading = false
    }
  }

  return {
    ...toRefs(state),
    fetchAllPositions,
  }
}
